export const PRODUCT_USAGE_TYPES = Object.freeze({
    WHAT_IT_IS: 'what_it_is',
    WHO_IT_IS_FOR: 'who_it_is_for',
    WHAT_IT_DOES: 'what_it_does',
    HOW_IT_WORKS: 'how_it_works',
    HOW_DOES_IT_WORK: 'how_does_it_work',
    GREAT_TO_KNOW: 'great_to_know',
    HOW_TO_USE: 'product_usage'
});
